import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

export function validationFunctionAccountType(values) {
  const errors = {};
  // Custom Validations
  return errors;
}

export const validationSchemaAccountType = Yup.object().shape({
  name: Yup.string().required(),
});
